function OrganizationPosts({ enquiry }) {
  return <div className="page">Coming Soon</div>;
}

export default OrganizationPosts;
